export const canAccessSettingsAchPayments = ({
  hasRequiredPermissions,
  isDirectMember,
  isPartnerManaged,
  isUiPermissionRolesEnabled,
  isACHPaymentsEnabled,
}: {
  hasRequiredPermissions: boolean;
  isDirectMember: boolean;
  isPartnerManaged: boolean;
  isUiPermissionRolesEnabled: boolean;
  isACHPaymentsEnabled?: boolean;
}) =>
  isUiPermissionRolesEnabled &&
  isPartnerManaged &&
  isDirectMember &&
  hasRequiredPermissions &&
  isACHPaymentsEnabled;

export const SETTINGS_ACH_PAYMENTS_PERMISSIONS = [
  'team-members:read',
  'partner-access-policy:manage',
] as const;
